export default "__VITE_ASSET__UWM2178Q__"